import { type ResolvedThemeSpec, resolveThemeSpec } from "@loot-os/api-contract";
import { createContext, useContext } from "react";

/** The resolved choices of the theme in force: layout, stage, motion. */
export const ThemeSpecContext = createContext<ResolvedThemeSpec>(resolveThemeSpec());

/** The theme's choices, for patterns that lay out by them (never by a tenant's name). */
export function useThemeSpec(): ResolvedThemeSpec {
  return useContext(ThemeSpecContext);
}

/** The theme's layout choices: header, nav, chrome, mobile nav, chat. */
export function useLayout(): ResolvedThemeSpec["layout"] {
  return useContext(ThemeSpecContext).layout;
}
